import TextField from 'material-ui/TextField'
import OpenInNewIcon from 'material-ui/svg-icons/action/open-in-new'
import { default as SEVERITY_ICONS } from 'components/icons/SeverityIcons'

import './customTemplate.scss'

export default class CustomTemplate extends React.Component {
  static propTypes = {
    type:                 React.PropTypes.oneOf(['title', 'description']),
    checklist:            React.PropTypes.array.isRequired,
    helpLinks:            React.PropTypes.array,
    hintText:             React.PropTypes.string,
    onChange:             React.PropTypes.func.isRequired,
    template:             React.PropTypes.string,
    onInstructionView:    React.PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      variables: {
        template: this.props.template,
      },
      showInstructions: {},
    }
  }

  checkpointSeverity(point) {
    if (!point.condition) return 'info'
    if (this.state.variables[point.condition]) return 'info'
    if (point.optional) return 'optional'

    return point.critical ? 'danger' : 'warning'
  }

  setTemplate(value) {
    this.setState({
      variables: {
        template: value,
      },      
    })
    this.props.onChange(value)
  }

  showInstructions(key, truthy = true) {
    if (truthy && this.props.onInstructionView) this.props.onInstructionView()

    this.setState({
      showInstructions: {
        ...this.state.showInstructions,
        [key]: truthy,
      },
    })
  }

  renderCheckpoint(point, key) {
    const severity = this.checkpointSeverity(point)
    const { showInstructions } = this.state

    return (
      <div className="customTemplate__checkpoint" key={key}>
        <div className="customTemplate__checkpoint__title">
          {SEVERITY_ICONS[severity]}
          <span className="text small-spacing--left small-spacing--right">{point.text}{point.optional ? ' (optional)' : ''}</span>
          {point.instructions && !showInstructions[key] &&
            <a className="show-instructions" onClick={() => this.showInstructions(key)}>View instructions</a>
          }
        </div>
        {showInstructions[key] &&
          <div className="instructions">
            <ul>
              {point.instructions.map((instruction, index) => (
                <li key={`instruction-${index}`}>{instruction}</li>
              ))}
            </ul>
            <a className="hide-instructions" onClick={() => this.showInstructions(key, false)}>Hide instructions</a>
          </div>
        }
      </div>
    )
  }

  renderChecklist() {
    return (
      <div className="customTemplate__checklist">
        {this.props.checklist.map((point, index) => this.renderCheckpoint(point, `checkpoint-${index}`))}
      </div>
    )
  }

  renderHelpLinks() {
    if (!this.props.helpLinks) return null

    return (
      <div className="customTemplate__helpLinks">
        {this.props.helpLinks.map((item, index) => (
          <a
            key={`helplink-${index}`}
            className="customTemplate__helpLink"
            target="_blank"
            href={item.link}
          >
            <OpenInNewIcon color="#5750C5" />
            <span className="small-spacing--left">{item.label}</span>
          </a>
        ))}
      </div>
    )
  }

  renderInput() {
    const placeholder = this.props.type === 'title' ? 'Add a custom page title template'
                                                    : 'Add a custom meta description template'
    return (
      <div className="customTemplate__input">
        <TextField
          placeholder={placeholder}
          value={this.state.variables.template}
          name="template"
          fullWidth
          multiLine
          onChange={({ target: { value } }) => this.setTemplate(value)}
        />
        {this.props.hintText && <div className="hint">{this.props.hintText}</div>}
      </div>
    )
  }

  render() {
    return (
      <div className="customTemplate">
        {this.renderChecklist()}
        {this.renderHelpLinks()}
        {this.renderInput()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/templates/CustomTemplate.js